import React, { useState } from 'react'
import styles from './CombineClientsModal.module.scss'

const CombineClientsModal = ({ clients, defaultMainId }) => {
  const [mainId, setMainId] = useState(defaultMainId ?? clients[0]?.id)

  return (
    <div className={styles.wrapper}>
      <p className={styles.hint}>
        Выберите клиента, которого нужно <b>оставить</b>. Второй клиент будет
        удалён, а его данные (переписки, сделки, лиды, пустые поля) перейдут к
        основному.
      </p>

      <div className={styles.radioGroup}>
        {clients.map((c) => (
          <label
            key={c.id}
            className={`${styles.card} ${
              mainId === c.id ? styles.cardActive : ''
            }`}
          >
            <input
              type='radio'
              name='main_client_id'
              value={c.id}
              checked={mainId === c.id}
              onChange={() => setMainId(c.id)}
            />
            <div className={styles.cardBody}>
              <div className={styles.cardName}>{c.name}</div>
              <div className={styles.cardMeta}>
                {c.phone && c.phone} {c.email && c.email}
              </div>
            </div>
            {mainId === c.id && <span className={styles.badge}>Основной</span>}
          </label>
        ))}
      </div>

      <input type='hidden' name='main_client_id' value={mainId} readOnly />
    </div>
  )
}

export default CombineClientsModal
